export const environment = {
  production: false,
  apipath: 'https://apiembryo.octodone.com/api',
  checkoutpath: 'https://embryo.checkout.octodone.com',
  cdnUrl: "https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com",
  enabledMenus: ['main_nav_menu', 'notifications_menu', 'user_menu', 'mobile_user_menu_notifications'],
  storagekeys: {
    unhcookieaccept: 'unhide.ca',
    unhacceptlang: 'unhide.al',
    unhtoken: 'unhide.token',
    unhspace: 'unhide.space',
    unhuser: 'unhide.me'
  },
  applicationTitle: 'UNHIDE School',
  defaultAvatarUrl: 'https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/avatar.png',
  clientIdFacebook: '838749452958097',
  clientIdGoogle: '677186294365-akt50en2hk1i5a6ok6n3l2jgift51bk8.apps.googleusercontent.com',
  RDStationToken: '58aad83bd07df2e81c0fa1fc5a3f7226',
  apppath: "https://embryo.octodone.com",
  clickupApiPath: 'https://private-anon-f5bd8c69af-clickup20.apiary-proxy.com/api/v2',
  clickupJobApplyAuth: 'pk_3167463_J10QJD2KZE2DOMR7V2J09HL0OCJIAIRG',
  clickupJobApplyTemplateTaskId: 't-22habe5',
  clickupJobApplyList: '168865173',
  policyPrivacyFileUrl: 'https://drive.google.com/file/d/19y6D16DwaxSDe6G1xnGuSCiEFd-xq3lq/view?usp=sharing',
  policyUsageUrl: 'https://pages.unhideschool.com/termos-e-condições',
  vimeoToken: '38d4c2845cb98c55a67839e55be7c94f',
  apiVimeoPath: 'https://api.vimeo.com/me/videos',
};
